// native
import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// addon
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ContextMenuModule } from '@readcube/ngx-contextmenu';

// components
import { LoaderComponent } from './components/loader/loader.component';
import { SearchComponent } from './components/search/search.component';
import { FieldErrorComponent } from './components/field-error/field-error.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { SvgIconDefinitionsComponent } from './components/svg-icon-definitions/svg-icon-definitions.component';

// directives
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { PreventDefaultDirective } from './directives/prevent-default.directive';

// pipe
import { TruncatePipe } from './pipes/truncate.pipe';
import { BoldSpanPipe } from "./pipes/bold-span.pipe";
import { FormatAuthorPipe } from "./pipes/format-author.pipe";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DragDropModule,
    ContextMenuModule
  ],
  declarations: [
    LoaderComponent,
    SearchComponent,
    FieldErrorComponent,
    FileUploaderComponent,
    ProgressBarComponent,
    SvgIconComponent,
    SvgIconDefinitionsComponent,

    InfiniteScrollDirective,
    StopPropagationDirective,
    PreventDefaultDirective,

    TruncatePipe,
    BoldSpanPipe,
    FormatAuthorPipe
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DragDropModule,
    ContextMenuModule,

    LoaderComponent,
    SearchComponent,
    FieldErrorComponent,
    FileUploaderComponent,
    ProgressBarComponent,
    SvgIconComponent,
    SvgIconDefinitionsComponent,

    InfiniteScrollDirective,
    StopPropagationDirective,
    PreventDefaultDirective,

    TruncatePipe,
    BoldSpanPipe,
    FormatAuthorPipe
  ]
})
export class SharedModule { }